import { lazy } from "react";
import ProtectedRoute from './protected';
import DashboardBento from "../pages/dashboard/bento";
import ProductCreateForm from "../pages/product/create";
import CategoriesSection from "../pages/product/categorie";



const Dashboard = lazy(()=> import("../pages/dashboard"))

const Product = lazy(()=> import("../pages/product"))
const ProductDetails = lazy(()=> import("./../pages/product/detail"))

const User = lazy(()=> import("./../pages/user"))
const UserDetails = lazy(()=> import("./../pages/user/detail"))

const Notifications = lazy(()=> import("./../pages/dashboard/notification"))

const Commande = lazy(()=> import("./../pages/commande"))
const CommandeDetails = lazy(()=> import("./../pages/commande/detail"))

const Params = lazy(()=> import("./../pages/settings/"))
const ProductUpdateForm = lazy(()=> import("./../pages/product/update"))
const AdminDetails = lazy(()=> import("./../pages/settings/adminDetail"))

const PromotionsTable = lazy(()=>import("../pages/promo"));
const PromotionDetails = lazy(()=>import("../pages/promo/details"));

const  DeliveryScreen = lazy(()=>import("../pages/delevery")) ;
const DeliveryDetails = lazy(()=>import("../pages/delevery/details"));


export const dashboardRoutes = [
  
  {
    path: "/dashboard",
    element: <Dashboard/>, // Composant parent pour enterprise
    children: [
      {index : true, element : <ProtectedRoute allowedRoles={["admin", "root", "observer", "productManager"]} element={<DashboardBento/>}/>},

      { path: "product", element: <Product/>},
      { path: "product/:id", element: <ProductDetails/>},
      { path: "product/create", element: <ProductCreateForm/>},
      { path: "product/update/:id", element: <ProductUpdateForm/>},

      { path: "user", element: <User/>},
      { path: "user/:id", element: <UserDetails/>},

      { path: "notifications", element: <Notifications/>},

      { path: "orders", element: <Commande/>},
      { path: "orders/:id", element: <CommandeDetails/>},

      { path: "settings", element: <ProtectedRoute allowedRoles={["admin","root"]} element={<Params/>}/>},
      { path: "settings/admin/:id", element: <ProtectedRoute allowedRoles={["admin", "root"]} element={<AdminDetails/>}/>},

      {path : "category", element : <ProtectedRoute allowedRoles={["admin", "root"]} element={<CategoriesSection/>}/>},

      {path : "delivery", element : <ProtectedRoute allowedRoles={["admin", "root"]} element={<DeliveryScreen/>}/>},
      {path : "delivery/:id", element : <ProtectedRoute allowedRoles={["admin", "root"]} element={<DeliveryDetails/>}/>},
      
      {path : "promotion", element : <ProtectedRoute allowedRoles={["admin", "root"]} element={<PromotionsTable/>}/>},
      {path : "promotion/:id", element : <ProtectedRoute allowedRoles={["admin", "root"]} element={<PromotionDetails/>}/>}

    ],
  },
];